import React from 'react';
import { useTranslation } from 'react-i18next';

import T from 'shared/atoms/Typography';
import Dialog from 'shared/molecules/Dialog';
import ConfirmationDialog from 'shared/molecules/ConfirmationDialog';
import TransferOwnershipView from 'shared/organisms/TransferOwnershipView';
import { PLAYLIST_STATUS } from 'shared/const';
import theme from 'shared/themes/default';

import CopyFromExistingPlaylist from './CopyFromExistingPlaylist';
import CreateNewPlaylistDialog from './CreateNewPlaylistDialog';
import PlaylistSelectCourse from './PlaylistSelectCourse';
import SharePlaylistContainer from './SharePlaylistContainer';
import DeleteDialog from './DeleteDialog';
import PublishDialog from './PublishDialog';

import { usePlaylist } from '../../context';

const Dialogs = () => {
  const { t } = useTranslation();

  const {
    dialogs: {
      // Share open variables
      openPlaylistForm,
      openPauseDialog,
      openAddCoursesToPlaylist,
      openSharePlaylistDialog,
      openShowTransferOwnership,
      openCopyPlaylistForm,
      // Dialog status
      formStatus,
      // Dialog state variables
      pausePlaylistId,
      selectedPlaylistForReminder,
      setSelectedPlaylistForReminder,
      submittingReminder,
      transferValues,
      // Playlists dialogs
      onStatusUpdate,
      // Pause dialog
      onPauseCloseHandler,
      // Content dialog
      // Transfer dialog
      onTransferOwnershipHandler,
      onCloseTransferHandler,
      sendReminderHandler,
    },
    playlists: { playlistManagers },
  } = usePlaylist();

  return (
    <>
      {openCopyPlaylistForm && <CopyFromExistingPlaylist />}
      {openPlaylistForm && <CreateNewPlaylistDialog />}
      {openAddCoursesToPlaylist && <PlaylistSelectCourse />}
      {openSharePlaylistDialog && <SharePlaylistContainer />}
      {openShowTransferOwnership && (
        <TransferOwnershipView
          onSubmitHandler={onTransferOwnershipHandler}
          transferItemName={transferValues.name}
          usersToTransfer={playlistManagers
            .map((manager) => manager.user)
            .filter((manager) => manager.id !== transferValues.ownerId)}
          onClose={onCloseTransferHandler}
          formStatus={formStatus}
        />
      )}

      <DeleteDialog />

      <PublishDialog />

      <Dialog
        actions={[
          {
            ariaLabel: t('generic.cancel'),
            handler: () => setSelectedPlaylistForReminder(null),
            label: t('generic.cancel'),
            type: 'secondaryOutline',
            disabled: submittingReminder,
          },
          {
            ariaLabel: t('playlist.sendReminder'),
            handler: sendReminderHandler,
            label: t('playlist.sendReminder'),
            loading: submittingReminder,
          },
        ]}
        ariaLabel={t('playlist.sendReminder')}
        onClose={() => setSelectedPlaylistForReminder(null)}
        open={!!selectedPlaylistForReminder}
        title={t('watchData.sendReminder')}
      >
        <T color={theme.palette.pureDark}>
          {t('playlist.sendReminderDialogText')}
        </T>
      </Dialog>

      <ConfirmationDialog
        open={openPauseDialog}
        ariaLabel={t('playlist.pause')}
        title={t('playlist.pause')}
        description={t('playlist.confirmPause')}
        cancelText={t('generic.cancel')}
        confirmText={t('playlist.pause')}
        onCancel={onPauseCloseHandler}
        onClose={onPauseCloseHandler}
        formStatus={formStatus}
        onConfirm={() =>
          onStatusUpdate(pausePlaylistId, PLAYLIST_STATUS.PAUSED)
        }
      />
    </>
  );
};

export default Dialogs;
